export default {
  paged: {
    select: 'id,status,created,title,destinationDisplay',
    searchSelect: ['title', 'destinationDisplay'],
  },
  item: {
    expand: {
      agent: { select: 'id,name' },
      processInstance: { select: 'id,name' },
    },
  },
};
